import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconDownload = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconDownload.dimensions.width} ${IconDownload.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="m0 5.43.006-.081c.005-.38.018-.76.013-1.139-.006-.45.362-.789.68-.866a.996.996 0 0 1 .233-.025c.744 0 1.49.004 2.234.006.168 0 .293.154.26.362-.023.135-.123.223-.27.228-.213.007-.426.01-.638.013l-1.582.021c-.062.001-.124.002-.178.046a.261.261 0 0 0-.107.214c-.002.575-.01 1.15-.01 1.726C.638 7.057.64 8.179.643 9.3c0 .108.005.218.01.326a.26.26 0 0 0 .246.235h8.2a.257.257 0 0 0 .248-.238c.006-.208.012-.416.012-.623 0-1.502 0-3.004-.002-4.505 0-.106-.005-.211-.01-.317-.005-.113-.094-.216-.206-.222a19.367 19.367 0 0 0-.683-.02c-.508-.007-1.017-.012-1.525-.018l-.062-.002c-.226.008-.322-.169-.299-.356a.281.281 0 0 1 .27-.237c.651-.001 1.303-.007 1.954-.01.1-.001.2.001.301.003.298.004.527.141.705.371.125.16.178.341.179.546.003.938.017 1.876.017 2.814 0 .851-.013 1.702-.019 2.554-.002.337-.167.576-.438.754a.748.748 0 0 1-.414.122c-1.174.005-2.347.019-3.52.021-1.186.003-2.372-.002-3.557-.006-.383-.002-.765-.016-1.148-.015-.327.001-.562-.155-.743-.41a.751.751 0 0 1-.14-.44c-.002-.39-.01-.78-.015-1.17 0-.025-.004-.05-.006-.076V5.43Z"
      />
      <Path
        fill={color || Color.premiumBlack}
        d="M4.688 6.951v-.078l.007-5.649c0-.152.006-.303.01-.454a.272.272 0 0 1 .201-.258c.128-.028.25-.012.335.104.024.033.043.079.044.12.01.258.018.517.019.775l.019 5.348v.08l.05-.047.983-.972a.283.283 0 0 1 .331-.065c.115.052.187.17.182.3a.247.247 0 0 1-.073.168c-.202.21-.4.423-.606.628-.313.312-.63.62-.947.93a.819.819 0 0 1-.1.08c-.105.073-.206.075-.303-.011a10.524 10.524 0 0 1-.454-.426c-.39-.393-.78-.789-1.166-1.186a.28.28 0 0 1-.042-.363.309.309 0 0 1 .36-.132c.026.008.05.027.07.047.271.263.541.527.81.792.088.085.173.172.27.27Z"
      />
    </Svg>
  )
}

IconDownload.dimensions = {
  width: 10,
  height: 11,
}

export default IconDownload
